import { dateTime } from '@/_shared';

const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export function getMonthOptions() {
  const monthsOptions: { name: string; value: string }[] = [];
  for (let i = 0; i < months.length; i++) {
    monthsOptions.push({ name: `${months[i]}`, value: `${months[i]}` });
  }
  return monthsOptions;
}

export function getMonthOptionsByIndex() {
  const monthsOptions: { name: string; value: number }[] = [];
  for (let i = 0; i < months.length; i++) {
    monthsOptions.push({ name: `${months[i]}`, value: i + 1 });
  }
  return monthsOptions;
}

export function getYearOptions(startYear = 1824) {
  const curYear = dateTime.now().year();
  const estYear: { name: string; value: string }[] = [];
  for (let i = curYear; i >= startYear; i--) {
    estYear.push({ name: `${i}`, value: `${i}` });
  }
  return estYear;
}
